import React from 'react';
import StudentDetailsTabView from './student-details-menu';
import TeacherDetailsTabView from './teacher-details-menu';
import BasicDetails from 'screens/student-details/basic-details';
import Sessions from 'screens/student-details/sessions';
import Courses from 'screens/student-details/courses';
import Payment from 'screens/student-details/payments';
import AddOns from 'screens/student-details/add-ons';
import StudentTransferDetails from 'screens/student-details/student-transfer';
import PauseDetails from 'screens/student-details/pause-details';
import TeacherForm from 'screens/batch-assignment/teacher-form';
import TeacherPerformance from 'screens/batch-assignment/teacher-performance';
import TeacherPauseDetails from 'screens/batch-assignment/teacher-pause-details';
import {
  TEACHER_RETENTION_RATE_TAB,
  PAUSE_DETAILS_TAB,
  TRIAL_PROFILE,
} from 'constants/teacher-details';
import StudentTransferInit from './student-transfer-init';
import CsmDetailsMenu from './csm-details-menu';
import CsmAssignedTeachers from 'screens/csm-details/csm-assigned-teachers';
import CsmAssignedParents from 'screens/csm-details/csm-assigned-parents';
import TrialProfile from 'screens/batch-assignment/trial-profile';

export const STUDENT_TAB_MENU = [
  {
    name: 'Basic Details',
    path: 'basic-details',
    Component: BasicDetails,
  },
  {
    name: 'Sessions',
    path: 'sessions',
    Component: Sessions,
  },
  {
    name: 'Payments',
    path: 'payments',
    Component: Payment,
  },
  {
    name: 'Courses',
    path: 'courses',
    Component: Courses,
  },
  {
    name: 'Add-ons',
    path: 'add-ons',
    Component: AddOns,
  },
  {
    name: 'Transfer',
    path: 'student-transfer',
    Component: StudentTransferDetails,
  },
  {
    name: 'Pause',
    path: 'pause',
    Component: PauseDetails,
  },
];

export const TEACHER_TAB_MENU = [
  {
    name: 'Basic Details',
    path: 'basic-details',
    Component: TeacherForm,
  },
  {
    name: 'Creds',
    path: 'creds',
    Component: TeacherForm,
  },
  {
    name: 'Calendar',
    path: 'calendar',
    Component: TeacherForm,
  },
  {
    name: 'Classrooms',
    path: 'classrooms',
    Component: TeacherForm,
  },
  {
    name: 'Retention rate',
    path: TEACHER_RETENTION_RATE_TAB,
    Component: TeacherPerformance,
  },
  {
    name: 'Pause',
    path: PAUSE_DETAILS_TAB,
    Component: TeacherPauseDetails,
  },
  {
    name: 'Trial Profile',
    path: TRIAL_PROFILE,
    Component: TrialProfile,
  },
];

export const TABS_LIST = [
  {
    component: <StudentDetailsTabView />,
    path: '/students/:id',
  },
  {
    component: <TeacherDetailsTabView />,
    path: '/users/teachers/:id',
  },
  {
    component: <CsmDetailsMenu />,
    path: '/users/csm/:csmId',
  },
  {
    component: <StudentTransferInit />,
    path: '/student-transfer',
  },
];

export const CSM_TAB_MENU = [
  {
    name: 'Parents',
    path: 'parents',
    Component: CsmAssignedParents,
  },
  {
    name: 'Teachers',
    path: 'teachers',
    Component: CsmAssignedTeachers,
  },
];
